// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fc","catalogByServiceItem__title":"c-k_fe"};